export const updateRFPContent = (section, value, index, setDocumentData, enterPressed) => {
    if (enterPressed) {
       return
    }
    if (index !== undefined) {
        setDocumentData((prev) => {
        // If nothing changes, return the same object (prevents re-renders)
        if (prev[section][index] === value) return prev; 

        // Copy the array to avoid mutating state directly
        const updatedSection = [...prev[section]]; 
        updatedSection[index] = value; // Update the specific index

        return {
            ...prev, 
            [section]: updatedSection // Only update the specific section
        };
    })
    }
    else{
        setDocumentData((prev) => {
            // Prevent unnecessary re-renders if nothing changes
            if (prev[section] === value) return prev;
        
            return {
                ...prev, 
                [section]: value // Only update the specific section
            };
        });
        
    }
}